exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link[data-v-8d5fecd0]{cursor:pointer}.selected-category[data-v-8d5fecd0]{background-color:#50aaa9;border-color:#4ca1a0}.selected-item[data-v-8d5fecd0],.selected-special-category[data-v-8d5fecd0]{background-color:#d57700;border-color:#c87000}.option-button[data-v-8d5fecd0]{height:100%}.button-category[data-v-8d5fecd0]{height:110px}", ""]);

// exports
